<template>
  <div class="row wwf-form">

    <div v-if="!isInitialRequest">


<div v-if="!isInitialSubmitted">
      <div class="field" :class="email ? 'has-content' : ''">
        <input type="email" name="emailDetails" id="emailDetails" v-model="email" v-validate="'required|email'" :class="{'border-red': errors.has('emailDetails')}" placeholder="Email" data-vv-as="email">
        <label for="emailDetails">Email</label>
        <span class="wwf-alert"><p v-if="errors.first('emailDetails')">{{errors.first('emailDetails')}}</p></span>
      </div>

      <div class="form-buttons next single">
        <input type="button" size="sm" variant="primary" value="Submit" v-on:click="updateDetails"/>
      </div>
</div>

      <div v-if="isInitialSubmitted" class="alert-box">
        <p>Thank you, check your email and follow the instructions.</p>
      </div>

    </div>

    <div v-if="isInitialRequest">

<div v-if="!isInitialSubmitted">

      <div slot="header" class="text-center">
        <h2>Update your details</h2>
      </div>

      <div class="small-collapse">

        <div class="small-12 columns">
            <div class="field" :class="email ? 'has-content' : ''">
              <input disabled type="email" v-model="email" id="email" v-validate="'required|email'" :class="{'border-red': errors.has('email')}"/>
              <label for="email">Email</label>
              <span class="wwf-alert"><p v-if="errors.first('email')">{{errors.first('email')}}</p></span>   
            </div>
        </div>

        <div class="small-12 medium-6 columns left-field">
            <div class="field" :class="title ? 'has-content' : ''">
              <select name="title" placeholder="Title" v-model="title" id="title" v-validate="'required'" :class="{'border-red': errors.has('title')}">
                  <option value="" disabled selected>Select a title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Miss">Miss</option>
              </select>
              <label for="title">Title</label>   
              <span class="wwf-alert"><p v-if="errors.first('title')">{{errors.first('title')}}</p></span> 
            </div>
        </div>

        <div class="small-12 medium-6 columns right-field">
            <div class="field" :class="firstname ? 'has-content' : ''">
              <input type="text" placeholder="First name" v-model="firstname" v-validate="'required'" id="firstName" name="firstName" :class="{'border-red': errors.has('firstName')}"/>
              <label for="firstName">First name</label>
              <span class="wwf-alert"><p v-if="errors.first('firstName')">{{errors.first('firstName')}}</p></span> 
            </div>
        </div>

        <div class="small-12 medium-6 columns left-field">
            <div class="field" :class="lastname ? 'has-content' : ''">
              <input type="text" placeholder="Last name" v-model="lastname" id="lastName" v-validate="'required'" name="lastName" :class="{'border-red': errors.has('lastName')}"/>
              <label for="lastName">Last name</label>
              <span class="wwf-alert"><p v-if="errors.first('lastName')">{{errors.first('lastName')}}</p></span>  
            </div>
        </div>

        <div class="small-12 medium-6 columns right-field">
            <div class="field" :class="phone ? 'has-content' : ''">
              <input type="tel" placeholder="Phone" v-model="phone" id="phone" name="phone" v-validate="'required'" :class="{'border-red': errors.has('phone')}"/>
              <label for="phone">Phone</label>
              <span class="wwf-alert"><p v-if="errors.first('phone')">{{errors.first('phone')}}</p></span>   
            </div>
        </div>

        <div class="small-12 medium-6 columns left-field">
            <div class="field" :class="address ? 'has-content' : ''">
              <input type="text" placeholder="Address" v-model="address" id="address" name="address" v-validate="'required'" :class="{'border-red': errors.has('address')}"/>
              <label for="address">Address</label>
              <span class="wwf-alert"><p v-if="errors.first('address')">{{errors.first('address')}}</p></span>   
            </div>
        </div>

        <div class="small-12 medium-6 columns right-field">
            <div class="field" :class="city ? 'has-content' : ''">
              <input type="tel" placeholder="City" v-model="city" name="city" id="city" v-validate="'required'" :class="{'is-invalid': errors.has('city')}"/>
              <label for="city">City</label>
              <span class="wwf-alert"><p v-if="errors.first('city')">{{errors.first('city')}}</p></span>  
            </div>
        </div>

        <div class="small-12 medium-6 columns left-field">
            <div class="field" :class="postcode ? 'has-content' : ''">
              <input type="tel" placeholder="Postcode" v-model="postcode" name="postcode" v-validate="'required'" id="postcode" :class="{'is-invalid': errors.has('postcode')}"/>
              <label for="postcode">Postcode</label>
              <span class="wwf-alert"><p v-if="errors.first('postcode')">{{errors.first('postcode')}}</p></span>  
            </div>
        </div>

        <div class="small-12 medium-6 columns right-field">
            <div class="field" :class="state ? 'has-content' : ''">
              <label for="dateBirth">State</label>
              <select placeholder="Title" v-model="state" id="state" name="state" v-validate="'required'" :class="{'is-invalid': errors.has('state')}">
                  				<option value="" disabled selected>Select a state</option>
				<option value="NSW">NSW</option>
        <option value="ACT">ACT</option>
        <option value="NT">NT</option>
				<option value="SA">SA</option>
				<option value="WA">WA</option>
				<option value="VIC">VIC</option>
				<option value="QLD">QLD</option>
				<option value="TAS">TAS</option>
              </select>
              <span class="wwf-alert"><p v-if="errors.first('state')">{{errors.first('state')}}</p></span>  
            </div>
        </div>

        <div class="small-12 medium-6 columns left-field end">
            <div class="field" :class="country ? 'has-content' : ''">
              <input type="text" placeholder="Country" v-model="country" name="country" v-validate="'required'" id="country" :class="{'is-invalid': errors.has('country')}"/>
              <label for="country">Country</label>
              <span class="wwf-alert"><p v-if="errors.first('country')">{{errors.first('country')}}</p></span>  
            </div>
        </div>

        <div class="small-12 columns ud-row">
          <div class="updated-card" v-if="hasCredidCardChanged">
              <div class="card-info-head">New Card</div>
              <div><span class="info-label">Card Number:</span> {{maskedcard}}</div>
              <div><span class="info-label">Card Holder Name:</span> {{name}}</div>
              <div><span class="info-label">Expiry Date:</span> {{date}}</div>
              <div><span class="info-label">Card Type:</span> {{type}}</div>
              <a href="#" @click="updateCreditCard">Update credit card</a>
              <div class="alert-box red updatedetails alert-box-credit" >
                  You haven't saved your changes, please click 'update details' when you're finished.
              </div>
            </div>
            <div v-if="!hasCredidCardChanged">
            <a href="#" @click="updateCreditCard" class="ud-bttn">Update credit card</a>
            </div>

        </div>

        <div class="small-12 columns">
            <div class="form-buttons next single">
              <input type="button" size="sm" variant="primary" value="Update details" @click="saveDetails"/>
            </div>
        </div>

      </div>

</div>

      <div v-if="isInitialSubmitted" class="alert-box">
        <p>Thank you for updating your details.</p>
      </div>

    </div>


            <!-- THANK YOU POPUP -->
            <div class="reveal ty-popup ud-popup thank-you-update" id="reveal-dialog-credit-card" data-reveal data-animation-in="fade-in" data-animation-out="fade-out">
                <div class="close"></div>
                <div class="bg"></div>
                <div class="row small-collapse popup-content wwf-popup open">
                    <div class="row">
                        <div class="small-12 columns text-center">
                            <h2>Update card details</h2>
                            <!-- BAMBORA CUSTOM CHECKOUT -->
                            <vue-bambora-custom-checkout v-if="useNewCheckout && isPopupOpen" submit-button-message="Update" @success="processSuccess"></vue-bambora-custom-checkout>
                            
                            <!-- OLD BAMBORA CHECKOUT -->
                            <iframe height="450px" width="400px" :src="iframeSrc" v-if="!useNewCheckout"></iframe>
                        </div>
                    </div>
                </div>
                <button class="close-button" data-close aria-label="Close modal" type="button">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>




  </div>
</template>

<script>

import VueBamboraCustomCheckout from "../product/VueBamboraCustomCheckout";
import { isEditMode } from '../../helpers';

export default {
  name: "updateDetails",
  components: {
    VueBamboraCustomCheckout
  },
  data() {
    return {
      productId: "update-details",
      isInitialRequest: false,
      isInitialSubmitted: false,
      iframeSrc: '',
      reveal: null,
      maskedcard : null,
      name: null,
      date: null,
      type: null,
      hasCredidCardChanged: false,
      isPopupOpen: false,
      useNewCheckout: false
    };
  },
  created: async function () {
    // Get value for the switch for Custom Checkout
    try {
      this.useNewCheckout = await this.$store.dispatch(
        "getCustomCheckoutFeatureSwitch",
        this.productId
      );
      console.log('this.useNewCheckout', this.useNewCheckout);
    } catch (err) {
      this.useNewCheckout = false;
      console.error("Cannot get feature switch - Back to old checkout");
    }
  },
  mounted: function() {

    // reveal-dialog-credit-card

    this.$store.dispatch("get_data_from_email_link").then(
      response => {
        // TODO: display message if not found
        // true/false
        this.isInitialRequest = response;
            if (!isEditMode()) {
      console.log('no editmode');
      this.reveal = new Foundation.Reveal($('#reveal-dialog-credit-card'));
    }
      },
      error => {
        console.error("get_firebase_data_from_quertstring_id error", error);
      }
    );
  },
  computed: {
    email: {
      get() {
        return this.$store.getters.update_details.email;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "email", value });
      }
    },
    title: {
      get() {
        return this.$store.getters.update_details.title;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "title", value });
      }
    },
    firstname: {
      get() {
        return this.$store.getters.update_details.firstname;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "firstname", value });
      }
    },
    lastname: {
      get() {
        return this.$store.getters.update_details.lastname;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "lastname", value });
      }
    },
    phone: {
      get() {
        return this.$store.getters.update_details.phone;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "phone", value });
      }
    },
    address: {
      get() {
        return this.$store.getters.update_details.address;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "address", value });
      }
    },
    state: {
      get() {
        return this.$store.getters.update_details.state;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "state", value });
      }
    },
    city: {
      get() {
        return this.$store.getters.update_details.city;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "city", value });
      }
    },
    postcode: {
      get() {
        return this.$store.getters.update_details.postalcode;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "postalcode", value });
      }
    },
    country: {
      get() {
        return this.$store.getters.update_details.country;
      },
      set(value) {
        this.$store.commit("updateDetail", { field: "country", value });
      }
    }
  },
  methods: {
    saveDetails: function() {
            return this.$validator.validateAll().then(result => {
              if (result) {
      // Check what field is mandatory
      this.$store.dispatch("update_new_details_to_firebase");
      this.isInitialSubmitted = true;
              }
            });
    },
    updateDetails: function() {
      return this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch("create_firebase_record_from_emailaddress");
          this.isInitialSubmitted = true;
        }
      });
    },
    updateCreditCard: function() {
      return new Promise((resolve, reject) => {
        // BAMBORA CUSTOM CHECKOUT
        if (this.useNewCheckout) {
          this.reveal.open();
          // We need to wait for the popup to be fully displayed before init the component
          setTimeout(() => {
            this.isPopupOpen = true;
          }, 400);

        } else {
          // OLD BAMBORA CHECKOUT
          this.$store.dispatch('update_details_checkout').then(response => { 
            this.reveal.open();
            this.iframeSrc = response.body.url
            this.isPopupOpen = true;
          });
        }
      });
    },
    confirmtransaction: function(maskedcard,name,date,type) { // OLD BAMBORA CHECKOUT
      console.log("maskedcard", maskedcard);
      console.log("name", name);
      console.log("date", date);
      console.log("type", type);
      this.maskedcard = maskedcard;
      this.name = name;
      this.date = date;
      this.type = type;
      this.hasCredidCardChanged = true;
      this.reveal.close();
    },
    processSuccess: function(event) {
      this.$store.dispatch("updateCreditCardDetails", event).then(result => {
        console.log('processSuccess - updateCreditCardDetails - result', result);
        this.maskedcard = result.TruncatedCard;
        this.name = result.cardHolderName;
        this.date = `${result.ExpM} / ${result.ExpY}`;
        this.type = result.CardType;
        this.hasCredidCardChanged = true;

        this.reveal.close();
        setTimeout(() => {
          this.isPopupOpen = false;
        }, 400);

      }).catch((err) => {
        this.$refs.checkout.reset(`We couldn't process your creadit card. Please try again.`);
      });
    },

  }
};
</script>

<style scoped>
.hide {
  display: none;
}

.alert-box-credit {
  clear: both;
  margin-bottom: 15px;
  display: block;
  color: black;
}

.thank-you-update {
  height: 500px;
}

.thank-you-update h2 {
  margin-bottom: 24px;
}

.card-info-head {
  margin-top: 12px;
  margin-bottom: 8px;
  font-weight: 600;
}

span.info-label{
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// UpdateDetails.vue?7cbf4ff4